import {SectionPageComponent} from './section-page-component';
import {StringTransformer} from './string-transformer';

export class IndividualDrivingLicensePosterSectionPageComponent extends SectionPageComponent<
  IndividualDrivingLicensePosterSectionPageComponent,
  'individualDrivingLicensePosterSection'
> {
  constructor(el: any = {}) {
    super(el, 'individualDrivingLicensePosterSection');
  }

  public override toJson(): any {
    return {
      ...super.toJson(),
    };
  }

  public override getSearchKeys(): string[] {
    return ['sectionTitle'];
  }

  public override applyStringTransformer(
    transformer: StringTransformer,
  ): IndividualDrivingLicensePosterSectionPageComponent {
    const res = new IndividualDrivingLicensePosterSectionPageComponent(
      this.toJson(),
    );

    res.sectionTitle = transformer.transform(this.sectionTitle);

    return res;
  }
}
